import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core";

import { MaintenanceWindow } from "../../../../../dtos/site";

import { MaintenanceTimeField } from "./MaintenanceTimeField";
import { MaintenanceDayField } from "./MaintenanceDayField";

const useStyles = makeStyles(() => ({
    container: {
        marginLeft: "30px",
        marginBottom: "20px",
        maxWidth: "800px",
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "10px",
    },
    timesContainer: {
        display: "flex",
        gap: "60px",
    },
    daysContainer: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        columnGap: "15px",
        rowGap: "5px",
    },
}));

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"] as const;

interface Props {
    configuration: MaintenanceWindow;
    setConfiguration: (value: MaintenanceWindow) => void;
    disabled: boolean;
}

export function MaintenanceWindowConfiguration({
    configuration,
    setConfiguration,
    disabled,
}: Props) {
    const classes = useStyles();

    const handleChange = useCallback((partialConfig: Partial<MaintenanceWindow>) => {
        setConfiguration({
            ...configuration,
            ...partialConfig,
        })
    }, [configuration, setConfiguration]);

    return (
        <div className={classes.container}>
            <div className={classes.timesContainer}>
                <MaintenanceTimeField
                    timeKey="startTime"
                    value={configuration.startTime}
                    onChange={handleChange}
                    disabled={disabled}
                />
                <MaintenanceTimeField
                    timeKey="endTime"
                    value={configuration.endTime}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>

            <div className={classes.daysContainer}>
                {DAYS.map((dayKey) => (
                    <MaintenanceDayField
                        key={dayKey}
                        dayKey={dayKey}
                        value={configuration[dayKey]}
                        onChange={handleChange}
                        disabled={disabled}
                    />
                ))}
            </div>
        </div>
    );
}